import React from 'react';
import { IInquiry } from '../../types/Inquiry'; // Asegúrate de tener la ruta correcta
import styles from '../../styles/Inquiries.module.css'; 
import { XMarkIcon, TruckIcon, QuestionMarkCircleIcon, PhoneIcon, MapPinIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

interface InquiryModalProps {
    inquiry: IInquiry;
    onClose: () => void;
}

const InquiryModal: React.FC<InquiryModalProps> = ({ inquiry, onClose }) => {
    // Helper para formatear la fecha
    const formatDate = (dateString: string) => {
        return new Date(dateString).toLocaleDateString('es-ES', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                
                <header className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>
                        {inquiry.subject}
                    </h2>
                    <button onClick={onClose} className={styles.closeButton} title="Cerrar">
                        <XMarkIcon className={styles.closeIcon} />
                    </button>
                </header>

                <div className={styles.modalBody}>
                    
                    {/* Metadatos (Tipo, Fecha, Estado) */}
                    <div className={styles.metaGrid}>
                        <div className={styles.metaItem}>
                            <span className={styles.metaLabel}>TIPO</span>
                            <div className={styles.metaValue}>
                                {inquiry.isQuote ? (
                                    <>
                                        <TruckIcon className={styles.metaIcon} /> Solicitud de Cotización
                                    </>
                                ) : (
                                    <>
                                        <QuestionMarkCircleIcon className={styles.metaIcon} /> Contacto General
                                    </>
                                )}
                            </div>
                        </div>
                        
                        <div className={styles.metaItem}>
                            <span className={styles.metaLabel}>ESTADO</span>
                            <div className={`${styles.metaValue} ${inquiry.isRead ? styles.statusRead : styles.statusUnread}`}>
                                {inquiry.isRead ? 'Leído' : 'Sin Leer'}
                            </div>
                        </div>
                        
                        <div className={styles.metaItem}>
                            <span className={styles.metaLabel}>RECIBIDO</span>
                            <span className={styles.metaValue}>{formatDate(inquiry.receivedAt)}</span>
                        </div>
                    </div>

                    {/* Información del Contacto */}
                    <h3 className={styles.sectionHeading}>Datos del Solicitante</h3>
                    <div className={styles.contactInfo}>
                        <p><EnvelopeIcon className={styles.contactIcon} /> <strong>Email:</strong> {inquiry.email}</p>
                        <p><PhoneIcon className={styles.contactIcon} /> <strong>Teléfono:</strong> {inquiry.phone || 'No proporcionado'}</p>
                        {inquiry.location && <p><MapPinIcon className={styles.contactIcon} /> <strong>Ubicación:</strong> {inquiry.location}</p>}
                    </div>

                    {/* Mensaje Principal */}
                    <h3 className={styles.sectionHeading}>Mensaje Original</h3>
                    <div className={styles.messageBox}>
                        {/* Muestra el mensaje respetando los saltos de línea */}
                        {inquiry.message.split('\n').map((line, index) => (
                            <p key={index}>{line}</p>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InquiryModal;